var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['message-input-toolbar', !_vm.isPC && 'message-input-toolbar-h5']
  }, [_c('div', {
    class: ['message-input-toolbar-list', !_vm.isPC && 'message-input-toolbar-h5-list']
  }, [_vm.props.inputToolbarList === undefined ? [_vm.isPC ? _c('EmojiPicker', {
    ref: "emojiPickerRef",
    attrs: {
      "isH5EmojiShow": _vm.isH5EmojiShow
    },
    on: {
      "insertEmoji": _vm.insertEmoji,
      "dialogShowInH5": _vm.dialogShowInH5,
      "dialogCloseInH5": _vm.dialogCloseInH5,
      "changeToolbarDisplayType": function (type) {
        return _vm.emits('changeToolbarDisplayType', type);
      },
      "sendMessage": _vm.sendMessage
    }
  }) : _vm._e(), _c('ImageUpload', {
    attrs: {
      "imageSourceType": "album",
      "isH5ToolShow": _vm.isH5ToolShow
    }
  }), _c('FileUpload', {
    attrs: {
      "isH5ToolShow": _vm.isH5ToolShow
    }
  })] : _vm._l(_vm.props.inputToolbarList, function (item, index) {
    return [_vm.isPC && item.presetId === _vm.INPUT_TOOLBAR_TYPE.EMOJI && item.isEnabled === 1 ? _c('EmojiPicker', {
      ref: "emojiPickerRef",
      refInFor: true,
      attrs: {
        "isH5EmojiShow": _vm.isH5EmojiShow
      },
      on: {
        "insertEmoji": _vm.insertEmoji,
        "dialogShowInH5": _vm.dialogShowInH5,
        "dialogCloseInH5": _vm.dialogCloseInH5,
        "changeToolbarDisplayType": function (type) {
          return _vm.emits('changeToolbarDisplayType', type);
        },
        "sendMessage": _vm.sendMessage
      }
    }) : item.presetId === _vm.INPUT_TOOLBAR_TYPE.IMAGE && item.isEnabled === 1 ? _c('ImageUpload', {
      attrs: {
        "imageSourceType": "album",
        "isH5ToolShow": _vm.isH5ToolShow,
        "title": item.title
      }
    }) : item.presetId === _vm.INPUT_TOOLBAR_TYPE.FILE && item.isEnabled === 1 ? _c('FileUpload', {
      attrs: {
        "isH5ToolShow": _vm.isH5ToolShow,
        "title": item.title
      }
    }) : item.presetId === _vm.INPUT_TOOLBAR_TYPE.VIDEO && item.isEnabled === 1 ? _c('VideoUpload', {
      attrs: {
        "videoSourceType": "album",
        "isH5ToolShow": _vm.isH5ToolShow,
        "title": item.title
      }
    }) : item.presetId === _vm.INPUT_TOOLBAR_TYPE.RATING && item.isEnabled === 1 && _vm.isInHumanService ? _c('RatingTool', {
      attrs: {
        "isH5ToolShow": _vm.isH5ToolShow,
        "title": item.title
      }
    }) : item.isEnabled === 1 && item.isPreset === 0 && item.presetId !== _vm.INPUT_TOOLBAR_TYPE.EMOJI ? _c('UserDefineTool', {
      attrs: {
        "isH5ToolShow": _vm.isH5ToolShow,
        "title": item.title,
        "icon": item.icon,
        "type": item.type,
        "content": item.content
      }
    }) : _vm._e()];
  })], 2), _vm.isH5 ? _c('div', {
    ref: "h5Dialog",
    class: ['message-input-toolbar-h5-dialog']
  }) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }